const HOUR_MS = 60 * 60 * 1000;
const JST_OFFSET_MS = 9 * HOUR_MS;

export const CATALOG_REFRESH_HOUR_JST = 4;

/**
 * Returns the Japanese business date for the catalog cycle. A timestamp before
 * 04:00 JST still belongs to the previous day's shelf lineup.
 */
export function catalogDateFor(
  timestamp = Date.now(),
  refreshHourJst = CATALOG_REFRESH_HOUR_JST,
): string {
  return new Date(timestamp + JST_OFFSET_MS - refreshHourJst * HOUR_MS)
    .toISOString()
    .slice(0, 10);
}

export function millisecondsUntilNextCatalogRefresh(
  timestamp = Date.now(),
  refreshHourJst = CATALOG_REFRESH_HOUR_JST,
): number {
  const [year, month, day] = catalogDateFor(timestamp, refreshHourJst).split("-").map(Number);
  const nextRefresh = Date.UTC(year!, month! - 1, day! + 1, refreshHourJst - 9);
  return Math.max(nextRefresh - timestamp, 1_000);
}

export function secondsUntilNextCatalogRefresh(
  timestamp = Date.now(),
  refreshHourJst = CATALOG_REFRESH_HOUR_JST,
): number {
  return Math.max(60, Math.ceil(millisecondsUntilNextCatalogRefresh(timestamp, refreshHourJst) / 1000));
}
